/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import {
    Menu,
    Typography,
    Grid,
    TextField,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Alert,
} from '@mui/material';
import { format, sub, intervalToDuration } from 'date-fns';
import { Autorenew, AccessTime } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    getCurrentTime,
    getDateWithDifference,
    getDifferenceBetweenTwoDates,
    getForamttedDate,
    TIME_OPTIONS,
} from 'utils/time';
import { useDispatch, useSelector } from 'react-redux';
import { setTime, initiateInterval } from 'redux/time/timeSlice';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AppButton } from 'app/components/shared/AppButton';
import { compareAsc } from 'date-fns';

import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { AppIconButton } from '../app/components/shared/AppIconButton';
import { clearDataSource } from 'redux/userLog/userLogSlice';

const TipStyle = {
    fontSize: 14,
    fontWeight: 700,
};

export default function TimeMenu() {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const { currentTime, previousTime, range } = useSelector(
        state => state.time,
    );

    const [fromDate, setFromDate] = useState(new Date().setHours(0, 0, 0, 0));
    const [toDate, setToDate] = useState(new Date().setHours(23, 59, 59, 59));

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!range) {
            setNewTime(TIME_OPTIONS[9]);
        }
    }, []);

    const buttonTitle = () => (
        <>
            <Typography sx={TipStyle}>{previousTime}</Typography>
            <Typography sx={{ textAlign: 'center', ...TipStyle }}>
                To
            </Typography>
            <Typography sx={TipStyle}>{currentTime} </Typography>
        </>
    );

    const setNewTime = option => {
        const { value } = option;
        const currentTime = getCurrentTime();
        const previousTime = getDateWithDifference({ currentTime, ...value });
        const datesDifference = getDifferenceBetweenTwoDates(
            previousTime,
            currentTime,
        );
        const previous7daysTime = getDateWithDifference({
            currentTime,
            days: 7,
        });
        dispatch(
            setTime({
                currentTime,
                previousTime,
                range: option,
                datesDifference,
                previous7daysTime,
            }),
        );
    };

    const handleSelection = ({ label, value }) => {
        setNewTime({ label, value });
        dispatch(clearDataSource());
        handleClose();
    };

    const _isDateSelectionError = () => {
        const isValid = compareAsc(fromDate, toDate);
        return !(isValid < 0);
    };

    const applyCustomDates = () => {
        const date1 = getForamttedDate(fromDate);
        const date2 = getForamttedDate(toDate);
        const datesDifference = getDifferenceBetweenTwoDates(date1, date2);
        if (datesDifference.days > 6) {
            alert('Please select dates with a difference of 7 days or less.');
            return;
        }
        const label = `${date1} To ${date2}`;
        dispatch(
            setTime({
                currentTime: date2,
                previousTime: date1,
                range: {
                    label,
                },
                datesDifference,
                previous7daysTime: getDateWithDifference({
                    currentTime: date2,
                    days: 7,
                }),
            }),
        );
        dispatch(clearDataSource());
        handleClose();
    };

    const _refreshDashboard = () => {
        dispatch(initiateInterval());
    };

    const _refreshButton = () => (
        <AppIconButton action={_refreshDashboard}>
            <Autorenew />
        </AppIconButton>
    );

    return (
        <div>
            <AppIconButton action={handleClick} tooltip={buttonTitle()}>
                <AccessTime />
                <Typography sx={{ pl: 1, pr: 1 }}>{range?.label}</Typography>
                <KeyboardArrowDownIcon />
            </AppIconButton>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                PaperProps={{ style: styles.container }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6} style={styles.absoluteContainer}>
                        <Typography> Absolute time range</Typography>

                        {_isDateSelectionError() && (
                            <Alert severity="error">
                                Please check selected dates.
                            </Alert>
                        )}
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDateTimePicker
                                label="From"
                                value={fromDate}
                                onChange={newValue => {
                                    setFromDate(newValue);
                                }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        sx={styles.dateField}
                                    />
                                )}
                            />
                            <DesktopDateTimePicker
                                label="To"
                                value={toDate}
                                onChange={newValue => {
                                    setToDate(newValue);
                                }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        sx={styles.dateField}
                                    />
                                )}
                            />

                            <AppButton
                                style={{
                                    marginTop: 1,
                                    marginLeft: 2,
                                }}
                                variant="outlined"
                                action={applyCustomDates}
                                disabled={_isDateSelectionError()}
                            >
                                Apply Date Time Range
                            </AppButton>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <List
                            sx={{
                                width: '100%',
                                maxWidth: 360,
                                height: '280px',
                                overflow: 'auto',
                                bgcolor: 'background.default',
                            }}
                        >
                            {TIME_OPTIONS.map(option => (
                                <ListItemButton
                                    key={`list-button-${option.label}`}
                                    onClick={() => handleSelection(option)}
                                >
                                    <ListItem sx={{ padding: 0 }}>
                                        <ListItemText primary={option.label} />
                                    </ListItem>
                                </ListItemButton>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Menu>
            {/* {_refreshButton()} */}
        </div>
    );
}

const styles = {
    container: {
        width: '800px',
        height: '300px',
        maxWidth: '100%',
        left: 0,
        right: 0,
        padding: 2,
        overflow: 'hidden',
    },
    absoluteContainer: {
        paddingLeft: 30,
    },
    dateField: {
        marginTop: 2,
    },
};
